import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import JobOrderForm from '../../components/pageModule/Joborders/JobOrderForm';
import { updateJobOrder, fetchJobOrder, setSelected, clearCurrentJobOrder } from '../../store/modules/joborder/joborderActions';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const JobordersEdit = () => {
    const joborderState = useSelector(state => state.joborder);
    const dispatch = useDispatch();
    const { id } = useParams();
    const isInitialized = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleUpdate = async (formData) => {
        try {
            const response = await dispatch(updateJobOrder(id, formData));
            toast.success('Job order updated successfully', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            return response;
        } catch (error) {
            toast.error(error.message || 'Error updating job order', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        fetchSingle: (id) => dispatch(fetchJobOrder(id)),
        update: handleUpdate,
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
        clearCurrent: () => dispatch(clearCurrentJobOrder())
    };

    // Fetch function with proper dependencies using actions
    const fetchData = useCallback(async (id) => {
        try {
            setIsLoading(true);
            const data = await actions.fetchSingle(id);
            if(data) {
                const selectedIds = data.items.map(item => item?.item?.id);
                await actions.setItemsSelected({
                    key: 'itemIds',
                    data: selectedIds
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    }, [actions]);

    // Initial data fetch
    useEffect(() => {
        if (!isInitialized.current) {
            isInitialized.current = true;
            fetchData(id);
        }
    }, [fetchData, id]);

    // Cleanup when component unmounts
    useEffect(() => {
        return () => {
            actions.clearCurrent();
        };
    }, [actions]);

    return (
        <div className="row">
            {/* <div className='col-lg-12 mb-4'>
                <div className='card'>
                    <div className='card-body'>
                        <nav className="deal-progress">
                            <ol className="d-lg-flex flex-lg-wrap border-1 border-neutral-300 rounded-1 overflow-hidden list-inline mb-0">
                                <li className="progress-li position-relative d-lg-flex bg-neutral-50 flex-equal text-truncate overflow-hidden ">
                                    <a className="d-flex w-full" href="#">
                                        <span className="d-flex align-items-center px-4 py-2 text-base font-medium">
                                            <span className="progress-round d-flex size-7 flex-shrink-0 align-items-center justify-content-center rounded-circle bg-success">
                                                <svg className="size-6 text-white d-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"></path>
                                                </svg>
                                            </span>
                                            <span className="ms-3 fw-bold">Job Order</span>
                                        </span>
                                    </a>
                                    <div className="position-absolute d-none d-lg-block top-0 end-0 w-5 h-full">
                                        <svg className="h-full w-full text-neutral-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
                                            <path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                </li>
                                <li className="progress-li position-relative d-lg-flex bg-neutral-50 flex-equal text-truncate overflow-hidden ">
                                    <a className="d-flex w-full" href="#">
                                        <span className="d-flex align-items-center px-4 py-2 text-base font-medium">
                                            <span className="progress-round d-flex size-7 flex-shrink-0 align-items-center justify-content-center rounded-circle rounded-circle border-neutral-400 border-gray">
                                                <svg className="size-6 text-gray d-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                                                    <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z"></path>
                                                </svg>
                                            </span>
                                            <span className="ms-3 fw-bold">Stock Issue</span>
                                        </span>
                                    </a>
                                    <div className="position-absolute d-none d-lg-block top-0 end-0 w-5 h-full">
                                        <svg className="h-full w-full text-neutral-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
                                            <path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor" stroke-linejoin="round"></path>
                                        </svg>
                                    </div>
                                </li>
                                <li className="progress-li position-relative d-lg-flex bg-neutral-50 flex-equal text-truncate overflow-hidden ">
                                    <a className="d-flex w-full" href="#">
                                        <span className="d-flex align-items-center px-4 py-2 text-base font-medium">
                                            <span className="progress-round d-flex size-7 flex-shrink-0 align-items-center justify-content-center rounded-circle rounded-circle border-neutral-400 border-gray">
                                                <svg className="size-6 text-gray d-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                                                    <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z"></path>
                                                </svg>
                                            </span>
                                            <span className="ms-3 fw-bold">Daily Production</span>
                                        </span>
                                    </a>
                                    <div className="position-absolute d-none d-lg-block top-0 end-0 w-5 h-full"><svg className="h-full w-full text-neutral-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none"><path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor" stroke-linejoin="round"></path></svg></div>
                                </li>
                                <li className="progress-li position-relative d-lg-flex bg-neutral-50 flex-equal text-truncate overflow-hidden ">
                                    <a className="d-flex w-full" href="#">
                                        <span className="d-flex align-items-center px-4 py-2 text-base font-medium">
                                            <span className="progress-round d-flex size-7 flex-shrink-0 align-items-center justify-content-center rounded-circle rounded-circle border-neutral-400 border-gray">
                                                <svg className="size-6 text-gray d-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                                                    <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z"></path>
                                                </svg>
                                            </span>
                                            <span className="ms-3 fw-bold">Job Costing</span>
                                        </span>
                                    </a>
                                    <div className="position-absolute d-none d-lg-block top-0 end-0 w-5 h-full"><svg className="h-full w-full text-neutral-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none"><path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor" stroke-linejoin="round"></path></svg></div>
                                </li>
                                <li className="progress-li position-relative d-lg-flex bg-neutral-50 flex-equal text-truncate overflow-hidden ">
                                    <a className="d-flex w-full" href="#">
                                        <span className="d-flex align-items-center px-4 py-2 text-base font-medium">
                                            <span className="progress-round d-flex size-7 flex-shrink-0 align-items-center justify-content-center rounded-circle rounded-circle border-neutral-400 border-gray">
                                                <svg className="size-6 text-gray d-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                                                    <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z"></path>
                                                </svg>
                                            </span>
                                            <span className="ms-3 fw-bold">Cash Memo</span>
                                        </span>
                                    </a>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div> */}
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <JobOrderForm 
                                    initialData={joborderState.current}
                                    onSave={async (data) => {
                                        try {
                                            const response = await actions.update(data);
                                            return response;
                                        } catch (error) {
                                            console.error('Error creating item:', error);
                                            throw error;
                                        }
                                    }}
                                    onClose={() => {
                                        console.log('cancel btn clicked')
                                    }}
                                    customActionsDispatch={actions}
                                    isLoading={isLoading}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default JobordersEdit; 